import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'Alchemist 1.0', href: '/alchemist' },
    { name: 'Anwendungen', href: '/anwendungen' },
    { name: 'Über uns', href: '/ueber-uns' },
    { name: 'Kontakt', href: '/kontakt' }
  ];

  return (
    <nav 
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/90 backdrop-blur-md border-b border-stone-200 py-3 shadow-sm' 
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center group">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/6a4e1632643f5ecd6b4b884d4518abad28ee28269a896d1a9bb8c081180db7d41fc79629d873bafacdf5fb95106d974d/images/aW1hZ2UvcG5n/c332d3ba3f3684a0e8ee690d3e7299be.png" 
            alt="CoreUnit Systems Logo" 
            className="h-14 md:h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-105" 
          />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link 
              key={link.name} 
              to={link.href}
              className={`text-sm font-bold uppercase tracking-wider transition-colors ${
                location.pathname === link.href 
                  ? 'text-emerald-600' 
                  : 'text-stone-600 hover:text-emerald-600'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <div className="h-6 w-px bg-stone-200 mx-2" />
          <span className="text-[10px] font-bold text-emerald-600 uppercase tracking-widest bg-emerald-50 px-3 py-1 rounded-full border border-emerald-100">
            A28 Hub
          </span>
        </div>

        <button 
          className="md:hidden text-stone-600"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
        </button>
      </div>

      {isMobileMenuOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden absolute top-full left-0 w-full bg-white border-b border-stone-200 py-6 px-6 flex flex-col gap-4 shadow-lg text-center"
        >
          {navLinks.map((link) => (
            <Link 
              key={link.name} 
              to={link.href}
              className="text-stone-600 hover:text-emerald-600 py-2 font-bold uppercase tracking-widest text-sm"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;